import pinyinEngine from './pinyinEngine';

export default function initGlobe(arrayEl) {
  let countryArr = [];
  // init country dropdown
  $.each(arrayEl,function(i){
    countryArr.push($(arrayEl[i]).text());
  });
  //init JS pingyin
  let engine = new pinyinEngine();
  engine.isFirstLetterSearchable = false;
  engine.resetCache();
  //init JS local pinyin search
  for (let index = 0; index < countryArr.length; index++) {
    engine.setCache(new Array(countryArr[index]), countryArr[index]);
  }
  //pingyin search
  $($("#specialAdvisory>.dropdown-menu").children()[0]).children().on("input",function(el){
    let arrySelect = [];
    $("#specialAdvisory>span.tag").each(function (index,el) {
      arrySelect.push($(el).text().trim());
    });

    if($(el.currentTarget).val() == ""){
      $("#specialAdvisory>.dropdown-menu>li[data-value=true]").remove();
      $.each(countryArr ,function(i) {
        let isShow = true;
        for (let j = 0; j < arrySelect.length; j++) {
          if(arrySelect[j] === countryArr[i]) { isShow = false; }
        }
        if(isShow){
          let list = $('<li data-value="true"><a href="javascript:;">' + countryArr[i] + '</a></li>');
          $(".countrysMenu").append(list);
        }else {
          let list = $('<li data-value="true" style="display: none;"><a href="javascript:;">' + countryArr[i] + '</a></li>');
          $(".countrysMenu").append(list);
        }
      });
    }else{
      $("#specialAdvisory>.dropdown-menu>li[data-value=true]").remove();
      engine.search($(el.currentTarget).val(),function(item){
        let isShow = true;
        for (let j = 0; j < arrySelect.length; j++) {
          if(arrySelect[j] === item) { isShow = false; }
        }
        if(isShow){
          let list = $('<li data-value="true"><a href="javascript:;">' + item + '</a></li>');
          $(".countrysMenu").append(list);
        }else {
          let list = $('<li data-value="true" style="display: none;"><a href="javascript:;">' + item + '</a></li>');
          $(".countrysMenu").append(list);
        }
      });
    }
  });
  $($("#travelAlert>.dropdown-menu").children()[0]).children().on("input",function(el){
    let arrySelect = [];
    $("#travelAlert>span.tag").each(function (index,el) {
      arrySelect.push($(el).text().trim());
    });

    if($(el.currentTarget).val() == ""){
      $("#travelAlert>.dropdown-menu>li[data-value=true]").remove();
      $.each(countryArr ,function(i){
        let isShow = true;
        for (let j = 0; j < arrySelect.length; j++) {
          if(arrySelect[j] === countryArr[i]) { isShow = false; }
        }
        if(isShow){
          let list = $('<li data-value="true"><a href="javascript:;">' + countryArr[i] + '</a></li>');
          $(".countrysMenu").append(list);
        }else {
          let list = $('<li data-value="true" style="display: none;"><a href="javascript:;">' + countryArr[i] + '</a></li>');
          $(".countrysMenu").append(list);
        }
      });
    }else{
      $("#travelAlert>.dropdown-menu>li[data-value=true]").remove();
      engine.search($(el.currentTarget).val(),function(item){
        let isShow = true;
        for (let j = 0; j < arrySelect.length; j++) {
          if(arrySelect[j] === item) { isShow = false; }
        }
        if(isShow){
          let list = $('<li data-value="true"><a href="javascript:;">' + item + '</a></li>');
          $(".countrysMenu").append(list);
        }else {
          let list = $('<li data-value="true" style="display: none;"><a href="javascript:;">' + item + '</a></li>');
          $(".countrysMenu").append(list);
        }
      });
    }
  });
  $($("#medical>.dropdown-menu").children()[0]).children().on("input",function(el){
    let arrySelect = [];
    $("#medical>span.tag").each(function (index,el) {
      arrySelect.push($(el).text().trim());
    });
    if($(el.currentTarget).val() == ""){
      $("#medical>.dropdown-menu>li[data-value=true]").remove();
      $.each(countryArr ,function(i){
        let isShow = true;
        for (let j = 0; j < arrySelect.length; j++) {
          if(arrySelect[j] === countryArr[i]) { isShow = false; }
        }
        if(isShow){
          let list = $('<li data-value="true"><a href="javascript:;">' + countryArr[i] + '</a></li>');
          $(".countrysMenu").append(list);
        }else {
          let list = $('<li data-value="true" style="display: none;"><a href="javascript:;">' + countryArr[i] + '</a></li>');
          $(".countrysMenu").append(list);
        }
      });
    }else{
      $("#medical>.dropdown-menu>li[data-value=true]").remove();
      engine.search($(el.currentTarget).val(),function(item){
        let isShow = true;
        for (let j = 0; j < arrySelect.length; j++) {
          if(arrySelect[j] === item) { isShow = false; }
        }
        if(isShow){
          let list = $('<li data-value="true"><a href="javascript:;">' + item + '</a></li>');
          $(".countrysMenu").append(list);
        }else {
          let list = $('<li data-value="true" style="display: none;"><a href="javascript:;">' + item + '</a></li>');
          $(".countrysMenu").append(list);
        }
      });
    }
  });
  //init globe data
  $.each(countryArr ,function(i){
    let list = $('<li data-value="true"><a href="javascript:;">'+countryArr[i]+'</a></li>');
    $(".countrysMenu").append(list);
  });
}


// WEBPACK FOOTER //
// ./src/container/subscribe/initGlobe.js